/**
 * @description Line，有序的线图
 */
import { __assign, __extends } from "tslib";
import Path from './path';
var Line = /** @class */ (function (_super) {
    __extends(Line, _super);
    function Line(cfg) {
        return _super.call(this, __assign({ type: 'line', sortable: true }, cfg)) || this;
    }
    return Line;
}(Path));
export default Line;
//# sourceMappingURL=line.js.map